import { API_URL } from '../config/apiConfig';

// Get trainer weekly notes for a specific week
export const getTrainerWeeklyNotes = async (affiliateId, weekStart) => {
    const token = localStorage.getItem('token');
    const response = await fetch(
        `${API_URL}/trainer-weekly-notes?affiliateId=${affiliateId}&weekStart=${weekStart.toISOString()}`,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }
    );

    if (!response.ok) {
        throw new Error('Failed to fetch trainer weekly notes');
    }

    return await response.json();
};

// Create or update trainer weekly note
export const upsertTrainerWeeklyNote = async (trainerId, affiliateId, weekStart, note) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/trainer-weekly-notes`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            trainerId,
            affiliateId,
            weekStart: weekStart.toISOString(),
            note
        })
    });

    if (!response.ok) {
        throw new Error('Failed to save trainer weekly note');
    }

    return await response.json();
};

// Delete trainer weekly note
export const deleteTrainerWeeklyNote = async (noteId) => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/trainer-weekly-notes/${noteId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to delete trainer weekly note');
    }

    return await response.json();
};

